import Select from "components/widgets/Select";
import useApp from "hooks/useApp";
import classNames from "utilities/ClassNames";
export default function OneGaugeConfiguration({
  oneGaugeBar,
  setOneGaugeBar,
  handleConfiguration,
  setScreen,
  configError,
}: any) {
  const { isScaled } = useApp();
  return (
    <form className="flex flex-col gap-3 w-11/12 mx-auto">
      {/* K1 */}
      <div className="flex flex-1 gap-3 w-full items-center">
        <div className="w-1/2">
          <input
            placeholder="Name"
            className={classNames(isScaled ? "text-lg h-11" : "", "input")}
            name="name"
            id="name"
            type="text"
            required
            value={oneGaugeBar?.k1.name}
            onChange={(e: any) =>
              setOneGaugeBar((prev: any) => ({
                ...prev,
                k1: {
                  ...oneGaugeBar?.k1,
                  name: e.target.value,
                },
              }))
            }
          />
        </div>
        <div className="w-1/2">
          <Select
            id={oneGaugeBar.k1.id}
            selectedValue={oneGaugeBar.k1.value.item}
            clear={() =>
              setOneGaugeBar((prev: any) => ({
                ...prev,
                k1: {
                  id: "",
                  name: "",
                  value: "",
                },
              }))
            }
            select={(item: any) => {
              setOneGaugeBar((prev: any) => ({
                ...prev,
                k1: {
                  ...oneGaugeBar.k1,
                  id: item.id,
                  value: item,
                },
              }));
            }}
          />
        </div>
      </div>
      <div className="flex gap-1 justify-end mt-3">
        <div className="text-red">{configError}</div>
        <div className="flex items-center gap-3">
          <div
            onClick={() => {
              setScreen("");
            }}
            className="btn-sec"
          >
            Cancel
          </div>
          <div onClick={handleConfiguration} className="btn">
            Commit
          </div>
        </div>
      </div>
    </form>
  );
}
